import { get, del, post, put } from "@utils/axios";

const api = "skills";

export const getAllSkillsReq = (payload) => {
  return get(`${api}?page=${payload.page}&filters=${payload.filters}`)
};

export const createSkillReq = (payload) => {
  return post(`${api}?`, payload);
};

export const updateSkillReq = (payload) => {
  return put(`${api}/${payload.id}`, payload);
};

export const deleteSkillReq = (id) => {
  return del(`${api}/${id}`);
};

export const getFilterReq = (payload) => {
  return get(`${api}?page=1&filters?company_id=1&fields=page=1&filters=organization_structure_fields_|company;preset_|grade;`)
}